import React from "react";
import {
    Select,
    Button,
    Space,
    DatePicker,
    Row,
    Col,
    Dropdown,
    Checkbox,
    Modal,
    Avatar,
    Image,
    Tooltip,
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import downloadIcon from "../assets/images/NewDesign/Download.svg";
import withRouter from "../withRouter";
import ListTable from "./ListTable";
import CompanyAutocomplete from "./CompanyAutocomplete";
import ShiftLogReportStore from "../store/ShiftLogReportStore";
import moment from "moment";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import VehicleStore from "../store/VehicleStore";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";
import PDF from "../assets/images/NewDesign/PDF.svg";
import Excel from "../assets/images/NewDesign/Excel.svg";
import DeviceGroupsForVehicles from "./DeviceGroupsForVehicles";
const { RangePicker } = DatePicker;

dayjs.extend(customParseFormat);

const defaultValue = moment().startOf("day").hour(0).minute(0).second(0);
const { Option } = Select;

let widthAdderFunc = (arr) => {
    let array = arr;
    array.map((val) => {
        if (val.title?.length > 24) {
            val.width = 250;
        } else if (val.title?.length > 15) {
            val.width = 200;
        } else if (val.title?.length > 12) {
            val.width = 150;
        } else if (val.title?.length > 8) {
            val.width = 125;
        } else {
            val.width = 110;
        }
    });

    return arr;
};
class ShiftLogReport extends React.Component {
    constructor(props, context) {
        super(props);
        this.handleTableChange = this.handleTableChange.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.ShiftLogReportStore = new ShiftLogReportStore(this);
        this.vehicleStore = new VehicleStore(this);

        this.state = {
            loading: false,
            pageSize: 50,
            currentPage: 1,
            company_name: "",
            listUpdated: 0,
            companyId: "",
            fromDate: dayjs().format("YYYY-MM-DD 00:00:00"),
            toDate: dayjs().format("YYYY-MM-DD HH:mm:ss"),
            selectedVehicles: [],
            selectedDriver: [],
            selectAllVehicles: false,
            modalVisible: false,
            column: "",
            filter: "",
            Notcompany: false,
            Notasset: false,
            filterby: "",

            selectedColumns: widthAdderFunc([

                {
                    // title: "Asset Name",
                    title: context.translate("_FLEET_DASHBORD_VEHICLE_VIEWICON_TITLE_"),
                    dataIndex: "vehicleNo",
                    key: "vehicleNo",
                    width: 150,
                    ellipsis: {
                        showTitle: true,
                    },
                }, {
                    title: context.translate("_DRIVER_"),
                    dataIndex: "driverName",
                    key: "driverName",
                    width: 100,
                    ellipsis: { showTitle: true }
                }, {
                    title: context.translate("_SHIFT_NUMBER_"),
                    dataIndex: "shiftNo",
                    key: "shiftNo",
                    width: 100,
                    ellipsis: { showTitle: true }
                },
                {
                    title: context.translate("_SHIFT_TYPE_"),
                    dataIndex: "shiftType",
                    key: "shiftType",
                    width: 100,
                    ellipsis: { showTitle: true }
                },
                {
                    title: context.translate("_SHIFT_START_TIME_"),
                    dataIndex: "shiftStartTime",
                    key: "shiftStartTime",
                    width: 100,
                    ellipsis: { showTitle: true }
                },
                {
                    title: context.translate("_SHIFT_OPEN_LATITUDE_"),
                    dataIndex: "openLatitude",
                    key: "openLatitude",
                    width: 110,
                    ellipsis: { showTitle: true }
                },
                {
                    title: context.translate("_SHIFT_OPEN_LONGITUDE_"),
                    dataIndex: "openLongitude",
                    key: "openLongitude",
                    width: 110,
                    ellipsis: { showTitle: true }
                },
                {
                    title: context.translate("_SHIFT_LOGOFF_DURATION_"),
                    dataIndex: "logoffDurationSec",
                    key: "logoffDurationSec",
                    width: 100,
                    ellipsis: { showTitle: true }
                },
                {
                    title: context.translate("_SHIFT_OPEN_DISTANCE_"),
                    dataIndex: "openShiftDistance",
                    key: "openShiftDistance",
                    width: 100,
                    ellipsis: { showTitle: true }
                },
                {
                    title: context.translate("_SHIFT_END_TIME_"),
                    dataIndex: "shiftEndTime",
                    key: "shiftEndTime",
                    width: 100,
                    ellipsis: { showTitle: true }
                },
                {
                    title: context.translate("_SHIFT_WAITING_TIME_"),
                    dataIndex: "shiftWaitingTimeSec",
                    key: "shiftWaitingTimeSec",
                    width: 100,
                    ellipsis: { showTitle: true }
                },
                {
                    title: context.translate("_SHIFT_TOTAL_DISTANCE_"),
                    dataIndex: "shiftTotalDistance",
                    key: "shiftTotalDistance",
                    width: 100,
                    ellipsis: { showTitle: true }
                },
                {
                    title: context.translate("_SHIFT_HIRED_DISTANCE_"),
                    dataIndex: "shiftHiredDistance",
                    key: "shiftHiredDistance",
                    width: 100,
                    ellipsis: { showTitle: true }
                },
                {
                    title: context.translate("_SHIFT_FOR_HIRE_DISTANCE_"),
                    dataIndex: "shiftForHireDistance",
                    key: "shiftForHireDistance",
                    width: 100,
                    ellipsis: { showTitle: true }
                },
                {
                    title: context.translate("_SHIFT_ON_CALL_DISTANCE_"),
                    dataIndex: "shiftOnCallDistance",
                    key: "shiftOnCallDistance",
                    width: 100,
                    ellipsis: { showTitle: true }
                },
                {
                    title: context.translate("_SHIFT_BLACK_TRIP_DISTANCE_"),
                    dataIndex: "shiftBlackTripDistance",
                    key: "shiftBlackTripDistance",
                    width: 100,
                    ellipsis: { showTitle: true }
                },
                {
                    title: context.translate("_SHIFT_TRIP_COUNT_"),
                    dataIndex: "tripsQuantity",
                    key: "tripsQuantity",
                    width: 100,
                    ellipsis: { showTitle: true }
                },
                {
                    title: context.translate("_SHIFT_FARE_AMOUNT_"),
                    dataIndex: "shiftFare",
                    key: "shiftFare",
                    width: 100,
                    ellipsis: { showTitle: true }
                },
                {
                    title: context.translate("_SHIFT_EXTRA_FARE_AMOUNT_"),
                    dataIndex: "shiftExtraFare",
                    key: "shiftExtraFare",
                    width: 100,
                    ellipsis: { showTitle: true }
                },
                {
                    title: context.translate("_SHIFT_STATUS_"),
                    dataIndex: "shiftStatus",
                    key: "shiftStatus",
                    width: 100,
                    ellipsis: { showTitle: true }
                },



            ]),
        };
        this.menuProps = {
            items: [
                {
                    label: (
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "5px",
                            }}
                        >
                            {" "}
                            <Image
                                style={{ height: "18px", width: "18px", borderRadius: "0px" }}
                                src={Excel}
                            ></Image>
                            {context.translate("_EXPORT_AS_EXCEL_")}
                        </div>
                    ),
                    key: "excel",
                },
                {
                    label: (
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "5px",
                            }}
                        >
                            {" "}
                            <Image
                                style={{ height: "18px", width: "18px", borderRadius: "0px" }}
                                src={PDF}
                            ></Image>
                            {context.translate("_EXPORT_AS_PDF_")}
                        </div>
                    ),
                    key: "pdf",
                },
            ],
            onClick: (val) => {
                let result = [];

                if (true) {
                    this.state.selectedColumns.map((obj) => result.push(obj.dataIndex));

                    console.log(this.state.fromDate, this.state.toDate);

                    var getData = {
                        companyId: this.state.companyId,
                        vehicleId: this.state.selectedVehicles,
                        fromDate: this.state.fromDate,
                        toDate: this.state.toDate,
                        driverId: this.state.selectedDriver,
                        filterBy: this.state.filterby,
                        colList: result.toString(),
                    };
                    if (val.key == "excel") {
                        this.ShiftLogReportStore.exportExcel(getData);
                    }
                    if (val.key == "pdf") {
                        this.ShiftLogReportStore.exportpdf(getData);
                    }

                }
            },
        };
        this.newColumns = [...this.state.selectedColumns,
        {
            title: context.translate("_UNIT_NO_"),
            dataIndex: "unitNo",
            key: "unitNo",
            width: 100,
            ellipsis: { showTitle: true },
        },
        {
            title: context.translate("_OPEN_UID_"),
            dataIndex: "openUid",
            key: "openUid",
            width: 100,
            ellipsis: { showTitle: true },
        },
        {
            title: context.translate("_CLOSE_UID_"),
            dataIndex: "closeUid",
            key: "closeUid",
            width: 100,
            ellipsis: { showTitle: true },
        },
        {
            title: context.translate("_OPEN_SPEED_"),
            dataIndex: "openSpeed",
            key: "openSpeed",
            width: 100,
            ellipsis: { showTitle: true },
        },
        {
            title: context.translate("_OPEN_GPS_FIX_"),
            dataIndex: "openGpsFix",
            key: "openGpsFix",
            width: 100,
            ellipsis: { showTitle: true },
        },
        {
            title: context.translate("_OPEN_IGNITION_"),
            dataIndex: "openIgnition",
            key: "openIgnition",
            width: 100,
            ellipsis: { showTitle: true },
        },
        {
            title: context.translate("_UNITS_QUANTITY_"),
            dataIndex: "unitsQuantity",
            key: "unitsQuantity",
            width: 100,
            ellipsis: { showTitle: true },
        },
        {
            title: context.translate("_FUEL_SURCHARGE_HIRED_KM_"),
            dataIndex: "fuelSurchargeHiredKm",
            key: "fuelSurchargeHiredKm",
            width: 100,
            ellipsis: { showTitle: true },
        },
        {
            title: context.translate("_DRIVER_SURCHARGE_HIRED_KM_"),
            dataIndex: "driverSurchargeHiredKm",
            key: "driverSurchargeHiredKm",
            width: 100,
            ellipsis: { showTitle: true },
        },
        {
            title: context.translate("_SHIFT_WAITING_TIME_FARE_"),
            dataIndex: "shiftWaitingTimeFare",
            key: "shiftWaitingTimeFare",
            width: 100,
            ellipsis: { showTitle: true },
        },
        {
            title: context.translate("_SHIFT_CREDIT_CARD_AMOUNT_"),
            dataIndex: "shiftCreditCardAmount",
            key: "shiftCreditCardAmount",
            width: 100,
            ellipsis: { showTitle: true },
        },
        {
            title: context.translate("_ITC_SURCHARGE_HIRED_KM_"),
            dataIndex: "itcSurchargeHiredKm",
            key: "itcSurchargeHiredKm",
            width: 100,
            ellipsis: { showTitle: true },
        },
        {
            title: context.translate("_DISCOUNT_CARD_TOTAL_AMOUNT_"),
            dataIndex: "discountCardTotalAmount",
            key: "discountCardTotalAmount",
            width: 100,
            ellipsis: { showTitle: true },
        },
        {
            title: context.translate("_COLLECT_TOTAL_"),
            dataIndex: "collectTotal",
            key: "collectTotal",
            width: 100,
            ellipsis: { showTitle: true },
        },
        {
            title: context.translate("_DRIVER_INCOME_"),
            dataIndex: "driverIncome",
            key: "driverIncome",
            width: 100,
            ellipsis: { showTitle: true },
        },
        {
            title: context.translate("_CLOSE_LATITUDE_"),
            dataIndex: "closeLatitude",
            key: "closeLatitude",
            width: 100,
            ellipsis: { showTitle: true },
        },
        {
            title: context.translate("_CLOSE_LONGITUDE_"),
            dataIndex: "closeLongitude",
            key: "closeLongitude",
            width: 100,
            ellipsis: { showTitle: true },
        },
        {
            title: context.translate("_CLOSE_SPEED_"),
            dataIndex: "closeSpeed",
            key: "closeSpeed",
            width: 100,
            ellipsis: { showTitle: true },
        },
        {
            title: context.translate("_CLOSE_GPS_FIX_"),
            dataIndex: "closeGpsFix",
            key: "closeGpsFix",
            width: 100,
            ellipsis: { showTitle: true },
        },
        {
            title: context.translate("_CLOSE_IGNITION_"),
            dataIndex: "closeIgnition",
            key: "closeIgnition",
            width: 100,
            ellipsis: { showTitle: true },
        },
        {
            title: context.translate("_TIPS_AMOUNT_"),
            dataIndex: "tipsAmount",
            key: "tipsAmount",
            width: 100,
            ellipsis: { showTitle: true },
        },
        {
            title: context.translate("_OVERSPEED_COUNT_"),
            dataIndex: "overspeedCount",
            key: "overspeedCount",
            width: 100,
            ellipsis: { showTitle: true },
        },
        {
            title: context.translate("_HARSH_BRAKE_COUNT_"),
            dataIndex: "harshBrakeCount",
            key: "harshBrakeCount",
            width: 100,
            ellipsis: { showTitle: true },
        },
        {
            title: context.translate("_HARSH_ACCEL_COUNT_"),
            dataIndex: "harshAccelCount",
            key: "harshAccelCount",
            width: 100,
            ellipsis: { showTitle: true },
        },
        {
            title: context.translate("_CREATED_AT_"),
            dataIndex: "createdAt",
            key: "createdAt",
            width: 100,
            ellipsis: { showTitle: true },
        },
        {
            title: context.translate("_UPDATED_AT_"),
            dataIndex: "updatedAt",
            key: "updatedAt",
            width: 100,
            ellipsis: { showTitle: true },
        },
        {
            title: context.translate("_CLOSE_REASON_"),
            dataIndex: "closeReason",
            key: "closeReason",
            width: 100,
            ellipsis: { showTitle: true },
        }

        ];
    }

    async componentDidMount() {
        if (Number(this.props.getUserData().isadmin) !== -1) {
            console.log(this.props.getUserData().userCompanyId);
            await this.setState({
                companyId: this.props.getUserData().userCompanyId,
            });
            await this.setState({ userId: this.props.getUserData().userId });
            await this.vehicleStore.getVehiclesCompanyId(
                this.props.getUserData().userCompanyId
            );
            await this.handleSearch();
        }
        this.setState({ pageSize: 50 });

        await this.setState({ column: this.state.selectedColumns });
    }

    async handleTableChange(pagination, filters, sorter) {
        //   console.log(pagination);
        await this.setState({
            currentPage: pagination.current,
            pageSize: pagination.pageSize,
        });
        // this.handleSearch();
        await this.showData();
    }
    onDateTimeChange = (dates) => {
        if (dates) {
            const format = "YYYY-MM-DD HH:mm:ss";
            this.setState({
                fromDate: dates[0].format(format),
                toDate: dates[1].format(format),
            });
        }
    };
    async handleChange(comp) {
        await this.setState({ Notcompany: false });
        await this.setState({ currentPage: 1, companyId: comp?.value });
        await this.setState({ selectedVehicles: [] });
        await this.vehicleStore.getVehiclesCompanyId(comp?.value);
        await this.setState({ listUpdated: 1 });
        await this.ShiftLogReportStore.getDriversByCompanyId({
            companyId: comp?.value,
        });
    }

    async handleSearch() {

        await this.setState({ loadData: 1 });
    }

    refreshList = async () => {
        this.setState({ loading: true });
        if (this.state.companyId) {
            await this.ShiftLogReportStore.loadData({
                companyId: this.state.companyId,
                vehicleId: this.state.selectedVehicles,
                fromDate: this.state.fromDate,
                toDate: this.state.toDate,
                offset: 0,
                limit: 50,
                filterBy: this.state.filterby,
                driverId: this.state.selectedDriver,
            });
        }
        this.setState({ loading: false, currentPage: 1 });
    };
    showData = async () => {
        if (!this.state.companyId) {
            this.setState({ Notcompany: true });
        } else {
            this.setState({ Notcompany: false });
        }
        if (!this.state.selectedVehicles) {
            this.setState({ Notasset: true });
        } else {
            this.setState({ Notasset: false });
        }
        if (!this.state.filterby) {
            this.setState({ NotFilter: true });
        } else {
            this.setState({ NotFilter: false });
        }
        if (this.state.companyId) {
            this.setState({ Notcompany: false, Notasset: false });
            await this.ShiftLogReportStore.loadData({
                offset: (this.state.currentPage - 1) * this.state.pageSize,
                limit: this.state.pageSize,
                companyId: this.state.companyId,
                vehicleId: this.state.selectedVehicles,
                fromDate: this.state.fromDate,
                toDate: this.state.toDate,
                pageNo: this.state.currentPage,
                filterBy: this.state.filterby,
                driverId: this.state.selectedDriver,

            });
            await this.setState({ listUpdated: 1 });
        }
    };
    handleSelectAllDrivers = async (e) => {
        if (this.state.selectAllDrivers) {
            const allDrivers = this.ShiftLogReportStore?.getDrivers.map((val) => {
                return val.driverId;
            });
            await this.setState({ selectedDriver: allDrivers });
        } else {
            await this.setState({ selectedDriver: [] });
        }
    };

    handleAllSelectVehicles = async (e) => {
        if (this.state.selectAllVehicles) {
            const allVehicles = this.vehicleStore?.getVehiclesUsingCompanyId.map(
                (val) => {
                    return val.vehicleId;
                }
            );
            await this.setState({ selectedVehicles: allVehicles });
        } else {
            await this.setState({ selectedVehicles: [] });
        }
    };

    handleCheckboxChange = async (column) => {
        console.log(column);
        if (this.state.selectedColumns.some((c) => c.key === column.key)) {
            const filtered = this.state.selectedColumns.filter(
                (c) => c.key !== column.key
            );
            console.log(filtered);
            await this.setState({
                selectedColumns: filtered,
            });
            await this.setState({ column: filtered });
        } else {
            console.log("adsf");
            await this.setState({
                selectedColumns: [...this.state.selectedColumns, column],
                column: [...this.state.selectedColumns, column],
            });
        }
    };


    render() {
        return (
            <>

                <div className="listHeader">
                    <Row className="listInputRow">

                        <Col span={16}>
                            <Space>
                                <CompanyAutocomplete
                                    className="searchInput"
                                    onChange={(value) => this.handleChange(value)}
                                    allowClear={true}
                                    style={{ width: 150 }}
                                    status={this.state.Notcompany ? "error" : false}
                                />
                                <Select
                                    style={{ width: 150 }}
                                    className="searchInput"
                                    status={this.state.NotFilter ? "error" : false}
                                    // placeholder='Filter by'
                                    placeholder={this.context.translate("_FILTER_BY_")}
                                    onChange={async (e) => {
                                        await this.setState({
                                            filterby: e,
                                            NotFilter: false,
                                        });
                                    }}
                                >
                                    <Select.Option value="Driver">
                                        {this.context.translate(
                                            "_FLEET_DASHBORD_HISTORY_TOOLTIP_DRIVER_"
                                        )}
                                    </Select.Option>
                                    <Select.Option value="Vehicle">
                                        {this.context.translate("_VEHICLES_")}
                                    </Select.Option>
                                </Select>

                                {this.state.filterby == "Driver" && (
                                    <>
                                        <Checkbox
                                            checked={this.state.selectAllDrivers}
                                            onChange={async (e) => {
                                                await this.setState({
                                                    selectAllDrivers: e.target.checked,
                                                });
                                                if (this.state.selectAllDrivers) {
                                                    await this.setState({
                                                        Notdriver: false,
                                                    });
                                                }
                                                console.log(e.target.checked);
                                                await this.handleSelectAllDrivers();
                                            }}
                                        />
                                        {this.context.translate("_ALL_")}
                                        <Select
                                            mode="multiple"
                                            className="searchInput"
                                            value={this.state.selectedDriver}
                                            maxTagCount="responsive"
                                            onChange={(val) => {
                                                this.setState({
                                                    selectedDriver: val,
                                                    Notdriver: false,
                                                });
                                                if (
                                                    this.ShiftLogReportStore?.getDrivers.length >
                                                    val.length
                                                ) {
                                                    this.setState({ selectAllDrivers: false });
                                                } else {
                                                    this.setState({ selectAllDrivers: true });
                                                }
                                            }}

                                            placeholder={this.context.translate(
                                                "_FLEET_DASHBORD_VEHICLE_INFORMATION_DRIVERNAME_"
                                            )}
                                            optionFilterProp="children"
                                            style={{ width: 150 }}
                                            status={this.state.Notdriver ? "error" : false}
                                            filterOption={(inputValue, option) => {
                                                if (option.children) {
                                                    return (
                                                        option.children
                                                            .toLowerCase()
                                                            .indexOf(inputValue.toLowerCase()) >= 0
                                                    );
                                                }
                                            }}
                                        >
                                            {this.ShiftLogReportStore?.getDrivers?.map((val) => {
                                                return <Option value={val.driverId}>{val.name}</Option>;
                                            })}
                                        </Select>
                                    </>
                                )}
                                {this.state.filterby === "Vehicle" && (
                                    <>
                                        {this.props.getUserData().isadmin === 1 && (
                                            <DeviceGroupsForVehicles
                                                vehicleStore={this.vehicleStore}
                                                setLoadDta={() => this.setState({ loadData: 1 })}
                                                resetVehicles={() =>
                                                    this.setState({
                                                        selectedVehicles: [],
                                                        selectAllVehicles: false,
                                                    })
                                                }
                                            />
                                        )}
                                        <Checkbox
                                            checked={this.state.selectAllVehicles}
                                            onChange={async (e) => {
                                                await this.setState({
                                                    selectAllVehicles: e.target.checked,
                                                });
                                                if (this.state.selectAllVehicles) {
                                                    await this.setState({
                                                        notvehicle: false,
                                                    });
                                                }
                                                console.log(e.target.checked);
                                                await this.handleAllSelectVehicles();
                                            }}
                                        />
                                        {this.context.translate("_ALL_")}
                                        <Select
                                            maxTagCount="responsive"
                                            className="searchInput"
                                            value={this.state.selectedVehicles}
                                            onChange={(val) => {
                                                this.setState({
                                                    selectedVehicles: val,
                                                    notvehicle: false,
                                                });
                                                if (
                                                    this.vehicleStore?.getVehiclesUsingCompanyId?.length >
                                                    val.length
                                                ) {
                                                    this.setState({ selectAllVehicles: false });
                                                } else {
                                                    this.setState({ selectAllVehicles: true });
                                                }
                                            }}
                                            style={{ width: 200 }}
                                            showSearch
                                            status={this.state.notvehicle ? "error" : false}
                                            mode="multiple"
                                            placeholder={this.context.translate(
                                                "_FLEET_DASHBORD_VEHICLE_VIEWICON_TITLE_"
                                            )}
                                            filterOption={(inputValue, option) => {
                                                if (option.children) {
                                                    return (
                                                        option.children
                                                            .toLowerCase()
                                                            .indexOf(inputValue.toLowerCase()) >= 0
                                                    );
                                                }
                                            }}
                                        >
                                            {this.vehicleStore?.getVehiclesUsingCompanyId?.map(
                                                (val) => {
                                                    return (
                                                        <Option value={val.vehicleId}>
                                                            {val.vehicleNo}
                                                        </Option>
                                                    );
                                                }
                                            )}
                                        </Select>
                                    </>
                                )}

                                <RangePicker
                                    placeholder={["From Datetime", "To Datetime"]}
                                    format="DD-MM-YYYY hh:mmA"
                                    style={{ width: 400, borderRadius: "25px" }}
                                    onChange={(val) => {
                                        const [start, end] = val;
                                        this.onDateTimeChange([start, end]);
                                    }}
                                    // disabledDate={(current) => {
                                    //     return current && current > dayjs();
                                    // }}
                                    showTime={{
                                        format: "h:mmA",
                                        defaultValue: [dayjs().startOf("day"), dayjs()],
                                    }}
                                    defaultValue={[dayjs().startOf("day"), dayjs()]}
                                />




                                <Button
                                    type="primary"
                                    onClick={async () => {
                                        await this.setState({ currentPage: 1, pageSize: 50 });
                                        await this.showData();
                                    }}
                                >
                                    {/* Show */}
                                    {this.context.translate("_FLEET_SHOW_BTN_")}
                                </Button>

                            </Space>
                        </Col>


                        <Col
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "end",
                            }}
                        // span={8}
                        >

                            <Button onClick={() => this.setState({ modalVisible: true })}>
                                {this.context.translate("_COLUMNS_")}
                            </Button>
                            <Tooltip
                                title={this.context.translate("_REFRESH_")}
                                placement="bottom"
                            >
                                <Image
                                    style={{
                                        height: 18,
                                        marginInlineEnd: "20px",
                                        alignItems: "center",
                                        cursor: "pointer",
                                    }}
                                    src={refreshIcon}
                                    onClick={() => this.refreshList()}
                                ></Image>
                            </Tooltip>

                            <Dropdown
                                disabled={
                                    this.ShiftLogReportStore?.shiftLogReport?.length > 0
                                        ? false
                                        : true
                                }
                                menu={this.menuProps}
                            >
                                <Button className="downloadExcelButton">
                                    <Image
                                        style={{
                                            height: 18,
                                            width: "auto",
                                        }}
                                        src={downloadIcon}
                                    />
                                </Button>
                            </Dropdown>

                        </Col>
                    </Row>

                    <Modal
                        open={this.state.modalVisible}
                        width={300}
                        title={this.context.translate("_SELECT_COLUMNS_")}
                        onCancel={() => this.setState({ modalVisible: false })}
                        onOk={() => {
                            this.setState({ modalVisible: false });
                        }}
                        footer={null}
                    >
                        <div style={{ maxHeight: "400px", overflowY: "auto" }}>
                            {this.newColumns.map((column, v) => {
                                return (
                                    <Row key={v}>
                                        <Col>
                                            <Checkbox
                                                onChange={() => this.handleCheckboxChange(column)}
                                                checked={this.state.selectedColumns.some(
                                                    (c) => c.key === column.key
                                                )}
                                            >
                                                {column.title}
                                            </Checkbox>
                                        </Col>
                                    </Row>
                                );
                            })}
                        </div>
                    </Modal>

                    <ListTable
                        currentPage={this.state.currentPage}
                        pageSize={this.state.pageSize}
                        total={this.ShiftLogReportStore?.total}
                        columns={this.state.column}
                        dataSource={this.ShiftLogReportStore?.shiftLogReport}

                        loading={this.ShiftLogReportStore?.loading}
                        onChange={this.handleTableChange}
                        scroll={{
                            x: 200,
                        }}
                    />
                </div>
            </>
        );
    }
}
ShiftLogReport.contextType = StoreContext;
export default observer(withRouter(ShiftLogReport));
